<script>
import {searchCouponColumns, UsageLogColumns} from "@/view/Coupons/searchColumns";
import usageLog from "./usage-log.vue";
import createCoupons from "@/view/Coupons/create-coupons.vue";
import raSimpleDialog from "@/components/ra-simple-dialog.vue";
import {getCouponList, sendCoupons, getCouponRecipients} from "@/api/coupon";
import { formatterSize } from '@/utils'
import {Axios} from '@/axios/axios'

export default {
  name: "coupon-view",
  components: {
    usageLog, createCoupons,raSimpleDialog
  },
  data() {
    return {
      activeName: 'coupons',
      searchColumns: searchCouponColumns,
      leftBtns: [
        {label: 'Coupons', name: 'coupons'},
        {label: 'Usage Log', name: 'usageLog'}
      ],
      page: 1,
      total: 0,
      rightBtns: [
        {
          label: 'NEW', name: 'new',
          bgColor: '#e95646',
        },
      ],
      couponList: [],
      searchParams: {},
      sendCouponModel: {
        object: ''
      },
      editRow: {},
      fileList: [],
      actionUrl:'https://plus.escroud.com',
      baseUrl: process.env.VUE_APP_BASE_URL,
      couponsLoading:false,
      recipientObj: {
        recipientPeople: [],
        recipientPage: 1,
        recipientTotal: 0,
        searchStr: '',
        loading: false
      }
    }
  },
  mounted() {
    this.getTableData();
  },
  computed: {
    config() {
      return { token: this.token };
    },
  },
  methods: {
    getTableData() {
      this.couponsLoading = true
      getCouponList({...this.searchParams, limit: 10, page: this.page}).then(res => {
        this.couponsLoading = false
        if (res.code === 200) {
          this.couponList = res.data.list;
          this.couponList.forEach(item=>{
            const dateTime = item.deadline.split(' ')
            item.deadline = dateTime[0] + ' ' + this.formattedTime(dateTime[1])
          })
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    formattedTime(data) {
      // 将时间字符串拆分为小时、分钟和秒
      const [hours, minutes, seconds] = data.split(':');

      // 创建一个 Date 对象，日期部分不重要，时间部分设置为传入的值
      const date = new Date();
      date.setHours(parseInt(hours, 10));
      date.setMinutes(parseInt(minutes, 10));
      date.setSeconds(parseInt(seconds, 10));

      // 使用 toLocaleTimeString 转换为 hh:mm A 格式
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });
    },
    pageHandler(page) {
      this.page = page;
      this.getTableData();
    },
    searchHandler(params) {
      this.searchParams = params;
      if (this.activeName == 'coupons'){
        this.page = 1
        this.getTableData();
      }else{
        this.$refs.usage_log.getUsageLog(params)
      }
    },
    leftClickHandler(name) {
      if (name === this.activeName) return
      this.page = 1
      this.activeName = name
      if (this.activeName === 'coupons') {
        this.rightBtns = [
          {
            label: 'NEW', name: 'new',
            bgColor: '#e95646',
          },
        ]
        this.searchColumns = searchCouponColumns
      } else {
        this.rightBtns = []
        this.searchColumns = UsageLogColumns
      }
    },
    updateHandle() {
      this.page = 1
      this.getTableData()
    },
    rightClickHandler() {
      this.editRow = {}
      this.$refs.create_coupons.couponsDialogFormVisible = true
    },
    typeHandler(row, column, cellValue) {
      if (cellValue === 1) return 'Flat rate'
      if (cellValue === 2) return 'Percentage'
    },
    ratePercentageHandle(row, column, cellValue) {
      if (row.type === 1) return '$' + cellValue
      if (row.type === 2) return cellValue + '%'
    },
    cancelSend() {
      this.$refs.sendForm.resetFields()
      this.$nextTick(() => {
        this.$refs.sendForm.clearValidate()
      })
    },
    cancelSendHandle(){
      this.$refs.stopSend.dialogVisible = false
    },
    stopSendCouponHandle(){
      let data ={
        coupon_no:this.editRow.coupon_no,
        status:0
      }
      sendCoupons('sendToNewUsers', data).then(res => {
        if (res.code === 200) {
          this.$message.success('stop successfully')
          this.$refs.stopSend.dialogVisible = false
          this.getTableData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    sendCouponHandle() {
      console.log(this.sendCouponModel,'sendCouponModel')
      let url = ''
      if (this.sendCouponModel.object === 'new') {
        url = 'sendToNewUsers'
      } else if (this.sendCouponModel.object === 'all') {
        url = 'sendToAllUsers'
      } else{
        return
      }
      this.$refs.sendForm.validate(valid => {
        if (valid) {
          let data = {}
          data.coupon_no = this.editRow.coupon_no
          if (this.sendCouponModel.object === 'new'){
              data.status = 1
          }
          sendCoupons(url, data).then(res => {
            if (res.code === 200) {
              this.$message.success('send successfully')
              this.$refs.sendCoupons.dialogVisible = false
              this.fileList = []
              this.cancelSend()
              this.getTableData()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    formatter(row, column, cellValue) {
      return formatterSize(cellValue)
    },
    recipientHandle({ recipients }) {
      if (recipients === 1) return 'All Users'
      if (recipients === 2) return 'New Users'
      if (recipients === 3) return 'Specified Users'
    },
    editHandle(row) {
      if (row.is_sended === 1) return
      if (row.spend_threshold == '0.00'){
        row.limitCheck = true
      }else{
        row.limitCheck = false
      }
      this.editRow = row
      this.$refs.create_coupons.couponsDialogFormVisible = true
    },
    copyHandle(row) {
      this.editRow = row
      delete this.editRow.id
      delete this.editRow.coupon_name
      this.$refs.create_coupons.couponsTitle = 'Copy a reward'
      this.$refs.create_coupons.couponsDialogFormVisible = true
    },
    stopSendHandle(row){
      console.log('ddd')
      this.sendCouponModel.object = 'new'
     this.editRow = row
      this.$refs.stopSend.dialogVisible = true
    },
    sendHandle(row) {
      this.editRow = row
      if (row.send_times > 0){
        this.sendCouponModel.object = 'new'
        let data = {}
        data.coupon_no = this.editRow.coupon_no
        data.status = 1
        sendCoupons('sendToNewUsers', data).then(res => {
          if (res.code === 200) {
            this.$message.success('send successfully')
            this.$refs.sendCoupons.dialogVisible = false
            this.fileList = []
            this.getTableData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }else{
        this.$refs.sendCoupons.dialogVisible = true
      }
    },
    showRecipientModal(row) {
      if (row.recipients !== 3) return
      this.editRow = row
      this.recipientObj.recipientPeople = []
      this.recipientObj.recipientPage = 1
      this.recipientObj.recipientTotal = 0
      this.$refs.recipients.dialogVisible = true
      this.getCouponRecipientsList()
    },
    httpRequest(data) {
      let _this = this;
      let file = data.file;
      let formData = new FormData();
      formData.append('file', file);
      formData.append('coupon_no', this.editRow.coupon_no);

      // 如果需要传递其他字段，可以继续添加
      // formData.append('fieldName', 'fieldValue');

      // 发送请求
      Axios.post('/adminapi/sendToSpecificUsers', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          "token":localStorage.getItem('token')
        }
      })
        .then(response => {
          // 处理响应
          if (response.code === 200) {
            this.$refs.sendCoupons.dialogVisible = false
            this.fileList = []
            this.cancelSend()
            this.getTableData()
            _this.$message({
              message: 'File has been uploaded',
              type: 'success'
            });
          } else {
            _this.$message({
              message: response.data.msg,
              type: 'warning'
            });
          }
        })
        .catch(error => {
          console.error('Error uploading file:', error);
        });
    },
    searchRecipient() {
      this.recipientObj.recipientPage = 1
      this.getCouponRecipientsList()
    },
    getCouponRecipientsList() {
      this.recipientObj.loading = true
      getCouponRecipients({
        coupon_no: this.editRow.coupon_no,
        page: this.recipientObj.recipientPage,
        limit: 5,
        search: this.recipientObj.searchStr
      }).then(res => {
        if (res.code === 200) {
          // res.data.recipients.total = 100
          // res.data.recipients.list = new Array(20).fill(res.data.recipients.list[0])

          this.recipientObj.recipientTotal = res.data.recipients.total;
          if (this.recipientObj.recipientPage === 1) {
            this.recipientObj.recipientPeople = res.data.recipients.list
          } else {
            this.recipientObj.recipientPeople = this.recipientObj.recipientPeople.concat(res.data.recipients.list);
          }
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.recipientObj.loading = false
      })
    },
    load() {
      if (this.recipientObj.recipientPage * 5 >= this.recipientObj.recipientTotal) return
      this.recipientObj.recipientPage+= 1;
      this.getCouponRecipientsList()
    }
  }
}
</script>

<template>
  <div>
    <page-title
        :left-btns="leftBtns"
        :right-btns="rightBtns"
        @leftClick="leftClickHandler"
        @rightClick="rightClickHandler"
    ></page-title>
    <ra-search-box
        class="mt-4"
        :search-fields="searchColumns"
        @search="searchHandler"
        @clear="searchHandler"
    ></ra-search-box>
    <div class="mt-4" v-loading="couponsLoading">
      <div v-if="activeName === 'coupons'">
        <el-table
            :data="couponList"
            v-if="couponList.length"
        >
          <el-table-column prop="coupon_no" label="Coupon No." align="center" width="180"/>
          <el-table-column prop="coupon_name" label="Coupon Name" align="center" width="220"/>
          <el-table-column prop="type" label="Type" align="center" width="120" :formatter="typeHandler"/>
          <el-table-column prop="rate" label="Rate/Percentage" align="center" width="180"
                           :formatter="ratePercentageHandle"/>
          <el-table-column prop="spend_threshold" label="Spend threshold" align="center" width="180"/>
          <el-table-column prop="deadline" label="Deadline" align="center" width="220"/>
          <el-table-column label="recipients" prop="recipients" width="180" align="center">
            <template slot-scope="scope">
              <div class="cursor-pointer" :class="{underline: scope.row.recipients === 3}" @click="showRecipientModal(scope.row)">{{recipientHandle(scope.row)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="valid_sizes" min-width="130" align="center" label="Valid sizes" :formatter="formatter"/>
          <el-table-column label="Actions" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="customer-action">
                <span>
                  <img v-if="scope.row.is_sended !== 1 && scope.row.send_times == 0" src="../../assets/coupons/edit@2x.png" class="w-4 mr-4 cursor-pointer" alt=""  @click="editHandle(scope.row)">
                  <img v-else src="../../assets/coupons/edit-disabled.png" class="w-4 mr-4 cursor-not-allowed" alt="">
                </span>
                <span class="cursor-pointer" @click="copyHandle(scope.row)">
                  <img src="../../assets/coupons/Duplicate@2x.png" class="w-4 mr-4" alt="">
                </span>
                <span  @click="sendHandle(scope.row)"  v-if="scope.row.is_sended == 0" style="cursor: pointer">
                  <img src="../../assets/coupons/send@2x.png" class="w-4 mr-4" alt="">
                </span>
                <span v-else>
                  <img v-if="scope.row.recipients == 2" src="../../assets/coupons/pause_can.png" class="w-4 mr-4 cursor-pointer" alt=""   @click="stopSendHandle(scope.row)">
                  <img  v-else src="../../assets/coupons/pause@2x.png" class="w-4 mr-4" alt="" >
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <table-empty v-else></table-empty>

        <ra-pagination
          :currentPage="page"
          :list-length="couponList.length"
          @pageChange="pageHandler"
          :total="total"
        ></ra-pagination>
      </div>
      <div v-else>
        <usage-log ref="usage_log"></usage-log>
      </div>

    </div>
    <createCoupons :row="editRow" @updateList="updateHandle" ref="create_coupons"></createCoupons>
    <ra-simple-dialog
        title="Send coupon(s)"
        ref="sendCoupons"
        cancel-btn-text="Cancel"
        confirm-btn-text="Submit"
        @confirmSubmit="sendCouponHandle"
        @cancel="cancelSend"
    >
      <el-form label-position="top" :model="sendCouponModel" class="mt-[-16px]" ref="sendForm" :show-message="false" status-icon>
        <el-form-item label=" Recipients" prop="object" required>
          <el-select v-model="sendCouponModel.object" placeholder="Select Recipients to receive coupons">
            <el-option label="New users" value="new" key="new"></el-option>
            <el-option label="All users" value="all" key="all"></el-option>
            <el-option label="Specified user" value="specified" key="specified"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Upload a table" required v-if="sendCouponModel.object === 'specified'">
          <el-upload
              class="upload-demo"
              multiple
              :limit="1"
              :action="actionUrl"
              :headers="config"
              :http-request="httpRequest"
              :file-list="fileList">
<!--            <div>-->
              <span class="text-[#E95646] text-sm underline pl-[10px]">Click to upload</span>
              <p slot="tip" class="text-[#E95646] mt-3 pl-[10px]">Please upload table to send coupons</p>
<!--            </div>-->
          </el-upload>
        </el-form-item>
      </el-form>
    </ra-simple-dialog>
    <ra-simple-dialog
        title="Recipients"
        ref="recipients"
    >
      <el-form :model="editRow" class="recipient mt-[-16px]">
        <el-form-item label="Coupon No.:"><span>{{editRow.coupon_no}}</span></el-form-item>
        <el-form-item label="Coupon Name:"><span>{{editRow.coupon_name}}</span></el-form-item>
        <el-form-item label="Receipients:">
          <el-input v-model="recipientObj.searchStr" @keyup.native.enter="searchRecipient" @blur="searchRecipient" placeholder="Search UID or recipients"></el-input>
        </el-form-item>
      </el-form>
<!--      <div class="h-[320px] mt-[6px]">-->
        <ul class="infinite-list h-[260px] mt-[6px]" v-infinite-scroll="load" style="overflow:auto" v-loading="recipientObj.loading">
          <li v-for="(item, index) in recipientObj.recipientPeople" :key="index" class="infinite-list-item mb-4">
            <img class="w-[40px] h-[40px] rounded-full" :src="baseUrl + item.avatar" alt="">
            <span class="ml-4">{{item.name}} (UID: {{item.uid}})</span>
          </li>
        </ul>
<!--      </div>-->
    </ra-simple-dialog>

    <ra-simple-dialog
      title="Stop issuing coupons"
      ref="stopSend"
      cancelBtnText="No"
      confirmBtnText="Yes"
      @confirmSubmit="stopSendCouponHandle"
      @cancel="cancelSendHandle"
    >
      <div>Would you like to stop issuing coupons? Please note that coupons already issued will not be affected.</div>
    </ra-simple-dialog>

  </div>
</template>

<style scoped lang="less">
.recipient{
  /deep/ .el-form-item__content {
    line-height: 52px;
  }
}
</style>
